import React from "react";

export default function BackdropsHero() {
    return (
        <section className="relative pt-24 md:pt-28 pb-12 overflow-hidden">
            {/* background image */}
             <div className="absolute inset-0">
        {/* <img
          src="/images/backdrops/hero.jpg"
          alt="PixlyBooth Backdrops"
          className="w-full h-full object-cover opacity-60"
        /> */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#05030D]/85 via-[#05030D]/45 to-[#05030D]"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(227,67,100,0.22),transparent_55%)]"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(159,92,255,0.20),transparent_55%)]"></div>
      </div> 

            <div className="relative max-w-6xl mx-auto px-4 md:px-8">
                <div className="max-w-3xl animate-fade-up">
                    <p className="text-xs uppercase tracking-[0.35em] text-pink-200/90 mb-3">
                        Background Beauty
                    </p>

                    <h1 className="text-4xl md:text-6xl font-extrabold leading-[1.05]">
                        Backdrops
                    </h1>

                    <p className="mt-5 text-sm md:text-base text-gray-200/90 leading-relaxed">
                        Backdrops set the vibe and elevate every shot — from timeless drapery
                        to modern shimmer and themed scenes. Choose your style, match your
                        event, and make every photo look premium.
                    </p>

                    <div className="mt-7 flex flex-wrap gap-3 ">
                        <a
                            href="#backdrop-gallery"
                            className="inline-flex items-center justify-center rounded-full bg-[#E34364] px-5 py-2.5 text-sm font-semibold
                         shadow-[0_18px_45px_rgba(227,67,100,0.45)] hover:bg-[#f15477] transition"
                        >
                            Explore Backdrops
                        </a>
                        <a
                            href="#contact"
                            className="inline-flex items-center justify-center rounded-full bg-white/10 border border-white/15
                         px-5 py-2.5 text-sm font-semibold hover:bg-white/15 transition"
                        >
                            Request a Quote
                        </a>
                    </div>

                    <div className="mt-8 flex flex-wrap gap-3 text-[12px] text-gray-200/80">
                        <span className="px-3 py-1 rounded-full bg-white/5 border border-white/10">
                            Weddings & Private Events
                        </span>
                        <span className="px-3 py-1 rounded-full bg-white/5 border border-white/10">
                            Corporate & Brands
                        </span>
                        <span className="px-3 py-1 rounded-full bg-white/5 border border-white/10">
                            Custom Themes Available
                        </span>
                    </div>
                </div>
            </div>
        </section>
    );
}
